/** Українська форма множини: 1 бал, 2 бали, 5 балів. */
export function plural(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(Math.trunc(n));
  const mod10 = abs % 10;
  const mod100 = abs % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}

export function coinsLabel(n: number): string {
  return `${n} ${plural(n, 'бал', 'бали', 'балів')}`;
}

export function hryvniaLabel(n: number): string {
  return `${n} грн`;
}

export function questionsLabel(n: number): string {
  return `${n} ${plural(n, 'питання', 'питання', 'питань')}`;
}

export function daysLabel(n: number): string {
  return `${n} ${plural(n, 'день', 'дні', 'днів')}`;
}

export function answersLabel(n: number): string {
  return `${n} ${plural(n, 'відповідь', 'відповіді', 'відповідей')}`;
}

export function minutesLabel(n: number): string {
  return `${n} ${plural(n, 'хвилина', 'хвилини', 'хвилин')}`;
}

export function formatClock(totalSeconds: number): string {
  const safe = Math.max(0, Math.floor(totalSeconds));
  const m = Math.floor(safe / 60);
  const s = safe % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

export function formatPercent(value: number, digits = 0): string {
  return `${(value * 100).toFixed(digits)}%`;
}

const dateFormatter = new Intl.DateTimeFormat('uk-UA', { day: 'numeric', month: 'long' });
const dateTimeFormatter = new Intl.DateTimeFormat('uk-UA', {
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
});

const timeFormatter = new Intl.DateTimeFormat('uk-UA', { hour: '2-digit', minute: '2-digit' });

/** Тільки година й хвилина: «о 16:00». Дата тут зайва — це сьогодні або завтра. */
export function formatTime(at: Date): string {
  return Number.isNaN(at.getTime()) ? '—' : timeFormatter.format(at);
}

export function formatDate(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : dateFormatter.format(d);
}

export function formatDateTime(iso: string | number): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : dateTimeFormatter.format(d);
}
